import React from 'react';

export interface LomavisAspectRatioBadgeProps {
  /** Display value such as 1:1, 4:5, or 9:16. */
  value: string;
  className?: string;
}

/**
 * Atom: a compact, presentation-only aspect-ratio label.
 */
export const LomavisAspectRatioBadge: React.FC<
  LomavisAspectRatioBadgeProps
> = ({ value, className = '' }) => (
  <span
    className={`badge bg-white text-muted border rounded-pill fw-semibold ${className}`}
    data-testid="aspect-ratio"
  >
    {value}
  </span>
);
